import { useAlert } from "./AlertContext";
import { useClient } from "./ClientContext";
import { useChat } from "./ChatContext";
import { useAppState } from "./AppStateContext";

export function useApp() {
  const alertContext = useAlert();
  const clientContext = useClient();
  const chatContext = useChat();
  const appStateContext = useAppState();

  return {
   
    showAlert: alertContext.showAlert,
    closeAlert: alertContext.closeAlert,
    alert: alertContext.alert,
    setAlert: alertContext.setAlert,

    clients: clientContext.clients,
    selectedClient: clientContext.selectedClient,
    setSelectedClient: clientContext.setSelectedClient,
    projects: clientContext.projects,
    archivedProjects: clientContext.archivedProjects,
    selectedProject: clientContext.selectedProject,
    setSelectedProject: clientContext.setSelectedProject,
    selectProject: clientContext.selectProject,
    loading: clientContext.loading,
    saveProgress: clientContext.saveProgress,
    createClient: clientContext.createClient,
    updateClient: clientContext.updateClient,
    createProject: clientContext.createProject,
    updateProject: clientContext.updateProject,
    deleteProject: clientContext.deleteProject,
    updateProjectIsArchived: clientContext.updateProjectIsArchived,
    refreshProjectFiles: clientContext.refreshProjectFiles,

   
    messages: chatContext.messages,
    setMessages: chatContext.setMessages,
    chatSessions: chatContext.chatSessions,
    currentChatSession: chatContext.currentChatSession,
    setCurrentChatSession: chatContext.setCurrentChatSession,
    createNewChat: chatContext.createNewChat,
    loadChatSession: chatContext.loadChatSession,
    deleteChatSession: chatContext.deleteChatSession,
    renameChatSession: chatContext.renameChatSession,
    updateSessionTitleByConversationId: chatContext.updateSessionTitleByConversationId,
    renamingConversationIds: chatContext.renamingConversationIds,
    addMessage: chatContext.addMessage,
    sendQuery: chatContext.sendQuery,
    stopGenerating: chatContext.stopGenerating,
    conversationContext: chatContext.conversationContext,
    setConversationContext: chatContext.setConversationContext,
    isGenerating: chatContext.loading,

    conversations: chatContext.conversations,
    privateConversations: chatContext.privateConversations,
    chatType: chatContext.chatType,
    selectedSilo: chatContext.selectedSilo,
    selectedSiloIsDefault: chatContext.selectedSiloIsDefault,
    selectedSiloTheme: chatContext.selectedSiloTheme,
    loadingConversations: chatContext.loadingConversations,
    loadingPrivateConversations: chatContext.loadingPrivateConversations,
    deletingConversationIds: chatContext.deletingConversationIds,
    setChatType: chatContext.setChatType,
    fetchConversationsBySilo: chatContext.fetchConversationsBySilo,
    fetchPrivateConversationsByClient: chatContext.fetchPrivateConversationsByClient,
    clearConversations: chatContext.clearConversations,
    clearActiveChatSession: chatContext.clearActiveChatSession,
    resetToDefaultHomeSilo: chatContext.resetToDefaultHomeSilo,
    defaultConversationsBySilo: chatContext.defaultConversationsBySilo,
    defaultPrivateConversationsBySilo: chatContext.defaultPrivateConversationsBySilo,

    activeMode: appStateContext.activeMode,
    setActiveMode: appStateContext.setActiveMode,
    sessionId: appStateContext.sessionId,
    setSessionId: appStateContext.setSessionId,
    goHome: appStateContext.goHome,
    useWebSearch: appStateContext.useWebSearch,
    setUseWebSearch: appStateContext.setUseWebSearch,
    selectedProviderId: appStateContext.selectedProviderId,
    setSelectedProviderId: appStateContext.setSelectedProviderId,
    selectedModelTier: appStateContext.selectedModelTier,
    setSelectedModelTier: appStateContext.setSelectedModelTier,
  };
}